import { Skeleton } from '@mui/material';
import { Box } from 'shared/mui/Box';

export function GatewayRulesFormSkeletonExpression(): JSX.Element {
  return (
    <Box sx={{ display: 'flex', gap: 2, width: '100%', mb: 2 }}>
      <Skeleton height={40} sx={{ flex: '1 1 1%' }} variant="rounded" />
      <Skeleton height={40} variant="rounded" width={250} />
      <Skeleton height={40} sx={{ flexGrow: 1 }} variant="rounded" />
      <Skeleton height={40} variant="circular" width={40} />
    </Box>
  );
}
